/**
 * @flow
 * @format
 */
/* global __DEV__ */

import analytics from './analytics';
import design from './design';
// import { sagas } from '../modules';

export default function* rootSaga(): Generator<*, *, *> {
  if (!__DEV__ && process.env.REACT_APP_TRACKING_ID.indexOf('UA-') !== -1) {
    yield* analytics();
  }
  yield* design();
  // yield sagas();
}



// WEBPACK FOOTER //
// ./src/sagas/index.js